import React, { useState } from 'react'
import { Modal, Button, Form, Row, Col } from 'react-bootstrap'

const onlyDigits = str => str.replace(/\D/g, '')

const formatCardNumber = digits => digits.replace(/(\d{4})(?=\d)/g, '$1 ').trim()

const formatExpiry = digits => {
  const d = digits.slice(0, 4)
  if (d.length <= 2) return d
  return `${d.slice(0, 2)}/${d.slice(2)}`
}

const UpdateCardModal = ({ show, onHide, onConfirm }) => {
  const [cardNumberRaw, setCardNumberRaw] = useState('')
  const [expiryRaw, setExpiryRaw] = useState('')
  const [cvc, setCvc] = useState('')
  const [error, setError] = useState('')

  const cardNumberDisplay = formatCardNumber(cardNumberRaw)
  const expiryDisplay = formatExpiry(expiryRaw)

  const handleCardChange = e => {
    const digits = onlyDigits(e.target.value).slice(0, 16)
    setCardNumberRaw(digits)
    setError('')
  }

  const handleExpiryChange = e => {
    const digits = onlyDigits(e.target.value).slice(0, 4)
    setExpiryRaw(digits)
    setError('')
  }

  const handleCvcChange = e => {
    const digits = onlyDigits(e.target.value).slice(0, 4)
    setCvc(digits)
    setError('')
  }

  const validate = () => {
    if (cardNumberRaw.length !== 16) return 'Card number must be 16 digits.'
    if (expiryRaw.length !== 4) return 'Expiry must be in MM/YY format.'
    const mm = parseInt(expiryRaw.slice(0, 2), 10)
    const yy = parseInt(expiryRaw.slice(2), 10)
    if (isNaN(mm) || mm < 1 || mm > 12) return 'Expiry month must be between 01 and 12.'

    if (cvc.length < 3) return 'CVC must be at least 3 digits.'

    return ''
  }

  const handleSave = () => {
    const v = validate()
    if (v) {
      setError(v)
      return
    }

    const payload = {
      cardNumber: cardNumberRaw,
      cardNumberFormatted: cardNumberDisplay,
      expiry: `${expiryRaw.slice(0, 2)}/${expiryRaw.slice(2)}`,
      cvc,
    }

    if (typeof onConfirm === 'function') onConfirm(payload)

    setCardNumberRaw('')
    setExpiryRaw('')
    setCvc('')
    setError('')
    onHide()
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Payment Method</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className='mb-3'>
            <Form.Label>Card Number</Form.Label>
            <Form.Control
              type='text'
              placeholder='1234 5678 9012 3456'
              value={cardNumberDisplay}
              onChange={handleCardChange}
              inputMode='numeric'
              maxLength={19}
            />
            <Form.Text className='text-muted'>
              Enter 16-digit card number. Spaces are inserted for readability.
            </Form.Text>
          </Form.Group>

          <Row>
            <Col>
              <Form.Group className='mb-3'>
                <Form.Label>Expiry Date</Form.Label>
                <Form.Control
                  type='text'
                  placeholder='MM/YY'
                  value={expiryDisplay}
                  onChange={handleExpiryChange}
                  inputMode='numeric'
                  maxLength={5}
                />
                <Form.Text className='text-muted'>Format: MM/YY</Form.Text>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className='mb-3'>
                <Form.Label>CVC</Form.Label>
                <Form.Control
                  type='text'
                  placeholder='123'
                  value={cvc}
                  onChange={handleCvcChange}
                  inputMode='numeric'
                  maxLength={4}
                />
                <Form.Text className='text-muted'>3 or 4 digit code</Form.Text>
              </Form.Group>
            </Col>
          </Row>

          {error && (
            <div className='alert alert-danger py-2' role='alert'>
              {error}
            </div>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outline-primary' onClick={onHide}>
          Close
        </Button>
        <Button variant='primary' onClick={handleSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default UpdateCardModal
